import { LoginAccount, StructureData } from "types";
import apiClient from "../lib/apiClients";

export const login = async (email: string, password: string) => {
  const response = await apiClient.post<LoginAccount>(
    process.env.REACT_APP_API_BASE_URL_1 + "",
    {
      email,
      password,
    },
  );

  return response?.data; // Return the response data instead of setting it in sessionStorage
};

export const policeLogin = async (email: string, password: string) => {
  const response = await apiClient.post<LoginAccount>(
    (process.env.REACT_APP_API_BASE_URL_3 ||
      process.env.REACT_APP_API_BASE_URL_POLICE) + "client_managements/login/",
    {
      username: email,
      password,
    },
  );

  return response?.data;
};

export const fetchStructure = async (admin_unit: string, org_unit: string) => {
  const response = await apiClient.get<StructureData>(
    `/appeal/appeal-requests/user-org-details/?admin_unit_uuid=${admin_unit}&org_unit_uuid=${org_unit}`,
  );
  return response?.data;
};
